export default "/institutions/truist.svg";